import React from "react";
import { NewsDetailData } from "../../../pages/NewsDetail/types";

export const NewsDetailContent: React.FC<{newsData:NewsDetailData}> = ({
  newsData
}) => {

  return (
      <p className="font-[Rubik] font-normal text-[14px] leading-[20px] text-[#666666] md:text-[16px] md:leading-[24px]">
        {newsData.body}
      </p>
  );
};

